module.exports = __webpack_public_path__ + "img/AD.abb4ef0d.svg";